import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import _ from 'lodash';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var matchedRouter, i, element, _loop, _i, hasToken, loadedPermissions, _yield$store$dispatch, permissions, accessRoutes;
    return regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          console.log('路由 ', from.path, ' → ', to.path);
          // if (process.env.VUE_APP_ENABLE_ROUTER_BEFOREACH) {
          //   next()
          //   return
          // }
          if (!_.has(to, 'meta.auth')) {
            _context2.next = 5;
            break;
          }
          if (_.get(to, 'meta.auth')) {
            _context2.next = 5;
            break;
          }
          next();
          return _context2.abrupt("return");
        case 5:
          // 解决三级菜单无法缓存，仅只满足三级菜单
          //缓存中保存原有的3级路由title值存入缓存
          matchedRouter = ["second"]; //存放需要保存功能的页面名称,这个地方按照你的项目中二级路由页面名称来确定
          for (i = 0; i < to.matched.length; i++) {
            element = to.matched[i];
            matchedRouter.push(element.meta.title);
          }
          sessionStorage.setItem("matchedRouter", JSON.stringify(matchedRouter));
          //修复三级路由不能保存状态问题
          if (!(to.matched && to.matched.length > 2)) {
            _context2.next = 16;
            break;
          }
          _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
            var element, Index;
            return regeneratorRuntime.wrap(function _loop$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  element = to.matched[_i];
                  Index = matchedRouter.findIndex(function (item) {
                    return item === element.name;
                  });
                  if (Index >= 0) {
                    to.matched.splice(_i, 1);
                  }
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _loop);
          });
          _i = 0;
        case 11:
          if (!(_i < to.matched.length)) {
            _context2.next = 16;
            break;
          }
          return _context2.delegateYield(_loop(), "t0", 13);
        case 13:
          _i++;
          _context2.next = 11;
          break;
        case 16:
          // 解决三级菜单无法缓存，仅只满足三级菜单
          // if (to.matched && to.matched.length > 2) {
          //   for (let i = 0; i < to.matched.length; i++) {
          //     const element = to.matched[i]
          //     if (element.components.default.name === 'Blank') {
          //       to.matched.splice(i, 1)
          //     }
          //   }
          // }

          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context2.next = 56;
            break;
          }
          if (!(to.path === '/login')) {
            _context2.next = 25;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          NProgress.done();
          _context2.next = 54;
          break;
        case 25:
          // next({ path: '/' })
          // NProgress.done()
          // next({ ...to, replace: true })
          // return;
          // 没有获取用户信息也显示主页
          // TODO 获取后台管理用户权限
          // determine whether the user has obtained his permission roles through getInfo
          loadedPermissions = store.getters.permissions != null;
          if (!loadedPermissions) {
            _context2.next = 30;
            break;
          }
          next();
          _context2.next = 54;
          break;
        case 30:
          _context2.prev = 30;
          _context2.next = 33;
          return store.dispatch('user/getInfo');
        case 33:
          _yield$store$dispatch = _context2.sent;
          permissions = _yield$store$dispatch.permissions;
          if (!_.isEmpty(permissions)) {
            _context2.next = 38;
            break;
          }
          next("/dashboard");
          return _context2.abrupt("return");
        case 38:
          _context2.next = 40;
          return store.dispatch('permission/generateRoutes', permissions);
        case 40:
          accessRoutes = _context2.sent;
          _context2.next = 43;
          return store.dispatch('user/getHammerAppFrameUrl');
        case 43:
          // dynamically add accessible routes
          // console.log('动态添加路由', accessRoutes);
          router.addRoutes(accessRoutes);

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context2.next = 54;
          break;
        case 47:
          _context2.prev = 47;
          _context2.t1 = _context2["catch"](30);
          _context2.next = 51;
          return store.dispatch('user/resetToken');
        case 51:
          Message.error(_context2.t1 || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 54:
          _context2.next = 57;
          break;
        case 56:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 57:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[30, 47]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});